import { useLocation, useNavigate } from "react-router-dom";
import {
  ROUTE_Purchase_One_Time,
  ROUTE_FATCA_CONFIRMATION,
  ROUTE_CUSTOMER_SUPPORT_SCREEN,

} from "../../Routes"; 
import axios from "../../libs/axiosConfig";
import Toast from "../../Components/ToastMsg/Toast";
import { selectPanNumber } from "../../Store/panNumberSlice";
import { useSelector } from "react-redux";
import { selectPhoneNumber } from "../../Store/MobileSlice";
import { selectRefreshToken } from "../../Store/Token/refreshTokenSlice";

const NseFatcaEnquiryapi = async () => {
  const Navigate = useNavigate();
  const panNumber = useSelector(selectPanNumber);
  const location = useLocation();
  const { iinNumber } = location.state || {};
  const phoneNumber = useSelector(selectPhoneNumber);

  const refreshToken = useSelector(selectRefreshToken);
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const requestBody = {
    nseFatcaEnquiry: {
      iin: iinNumber ,
      pan: panNumber,
    },
  };

  try {
    const response = await axios.post(
      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
      requestBody
    );

    const { nseFatcaEnquiryData } = response.data;
    const { status, nseFatcaEnquiry } = nseFatcaEnquiryData;

    if (status === "Success") {
      if (
        nseFatcaEnquiry.fatca_reg === "Y" 
        // &&nseFatcaEnquiry.fatca_verify_status === "Y"
      ) {
        Navigate(ROUTE_Purchase_One_Time);
      } else if (nseFatcaEnquiry.fatca_reg !== "Y") {
        // const CustomerKycDetailsResponse = await axios.get(
        //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken,
        //     },
        //   }
        // );

        // const response = CustomerKycDetailsResponse.data.data;
        // console.log(response, "Get api data");

        const FatcaApiResponse = await axios.post(
          "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
          {
            nseFatca: {
              mobile_no: phoneNumber,
              pan: panNumber,
              iin: iinNumber,
              investor_name: "",
              app_income_code: response.nseIncomeCode,
              occ_code: response.nseOccupationCode,
              dob: response.dob,
              log_name: response.emailId,
              country_of_birth: response.nseCountryCodeOfBirth,
              place_birth: response.placeOfBirth,
            },
          },
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
              // RefreshToken: refreshToken,
            },
          }
        );

        if (
          FatcaApiResponse.data.status === "true" &&
          FatcaApiResponse.data.statusCode === 200 &&
          FatcaApiResponse.data.body.status === "Success"
        ) {
          const recheckresponse = await axios.post(
            "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
            requestBody
          );
          const { nseFatcaEnquiryData } = recheckresponse.data;
          const { status, nseFatcaEnquiry } = nseFatcaEnquiryData;

          if (status === "Success") {
            if (
              nseFatcaEnquiry.fatca_reg === "Y" 
              // && nseFatcaEnquiry.fatca_verify_status === "Y"
            ) {
              Navigate(ROUTE_Purchase_One_Time);
            }
            else if (nseFatcaEnquiry.fatca_reg === "Y"
                                && nseFatcaEnquiry.fatca_verify_status !== "Y") 
                                
                                {
                                  const FatcaActivation = await axios.post(
                                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                    {
                                      FatcaActivation: {
                                        
                                        pan: panNumber,
                                        
                                      },
                                    },
                                    {
                                      headers: {
                                        Authorization: `Bearer ${storedToken}`,
                                        // RefreshToken: refreshToken,
                                      },
                                    }
                                  );

                                  const recheckresponse = await axios.post(
                                    "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
                                    requestBody
                                  );
                                  const { nseFatcaEnquiryData } =
                                    recheckresponse.data;
                                  const { status, nseFatcaEnquiry } =
                                    nseFatcaEnquiryData;

                                    if (status === "Success") {
                                      if (
                                        nseFatcaEnquiry.fatca_reg === "Y"
                                        // && nseFatcaEnquiry.fatca_verify_status === "Y"
                                      ) {
                                        Navigate(ROUTE_FATCA_CONFIRMATION)
                                    }
                                  }

                                }
          }
          else {
            if (status !== "Success") {
              Toast.error(response.data.errorMessage || "Failed");
            }
          }

          // Navigate(ROUTE_Purchase_One_Time);
        } else {
          Toast.error("Fatca failed");
          Navigate(ROUTE_CUSTOMER_SUPPORT_SCREEN, {
            state: {
              reason:
                "Your FATCA Failed",
            },
          });        }
      }
    } else {
      if (status !== "Success") {
        Toast.error(response.data.errorMessage || "Failed");
      }
    }
  } catch (error) {
    console.error("Error:", error);
    // Handle error
  }
};

export default NseFatcaEnquiryapi;
